import { createConfirmation } from 'react-confirm'
import { Confirmation } from '.'

// create confirm function
export const confirm = createConfirmation(Confirmation)

// This is optional. But wrapping function makes it easy to use.
export function confirmWrapper (confirmation, options = {}) {
  return confirm({ confirmation, options })
}
